(() => {
  const STORAGE_KEY = 'dikdik_wishlist';

  const getWishlist = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(stored) ? stored : [];
    } catch {
      return [];
    }
  };

  const updateButtons = () => {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const saved = items.includes(button.dataset.productHandle);
      button.classList.toggle('is-active', saved);
      button.classList.toggle('is-wishlisted', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  };

  const updateHeaderCount = () => {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((bubble) => {
      bubble.textContent = String(count);
      bubble.hidden = count === 0;
    });
  };

  const saveWishlist = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(items.filter(Boolean))]));
    updateButtons();
    updateHeaderCount();
  };

  const toggleProduct = (handle) => {
    if (!handle) return;
    const items = getWishlist();
    saveWishlist(items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle]);
    if (document.querySelector('[data-wishlist-page]')) renderWishlistPage();
  };

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&','&amp;')
    .replaceAll('<','&lt;')
    .replaceAll('>','&gt;')
    .replaceAll('"','&quot;')
    .replaceAll("'","&#039;");

  const formatMoney = (cents) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format((Number(cents) || 0) / 100);

  async function renderWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    const loading = document.querySelector('[data-wishlist-loading]');
    if (!grid || !empty || !loading) return;

    const handles = getWishlist();
    loading.hidden = false;
    empty.hidden = true;
    grid.innerHTML = '';

    if (!handles.length) {
      loading.hidden = true;
      empty.hidden = false;
      return;
    }

    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        return response.ok ? await response.json() : null;
      } catch {
        return null;
      }
    }));

    products.filter(Boolean).forEach((product) => {
      const url = `/products/${encodeURIComponent(product.handle)}`;
      grid.insertAdjacentHTML('beforeend', `
        <article class="dd-wishlist-card">
          <div class="dd-wishlist-card__media">
            <a href="${url}">
              <img class="dd-wishlist-card__image" src="${escapeHtml(product.featured_image || '')}" alt="${escapeHtml(product.title)}" loading="lazy">
            </a>
          </div>
          <div class="dd-wishlist-card__content">
            <h2 class="dd-wishlist-card__title"><a href="${url}">${escapeHtml(product.title)}</a></h2>
            <p class="dd-wishlist-card__price">${formatMoney(product.price)}</p>
            <button type="button" class="button button--secondary dd-wishlist-card__remove" data-wishlist-remove="${escapeHtml(product.handle)}">Remove</button>
          </div>
        </article>
      `);
    });

    loading.hidden = true;
    empty.hidden = grid.children.length > 0;
  }

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest('[data-wishlist-button]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleProduct(wishlistButton.dataset.productHandle);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleProduct(removeButton.dataset.wishlistRemove);
    }
  });

  const init = () => {
    updateButtons();
    updateHeaderCount();
    if (document.querySelector('[data-wishlist-page]')) renderWishlistPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) init();
  });
})();